import type { ParamType } from './ParamType';

export const getFromStorage = <T>(prop: ParamType | string): T | undefined => {
    if (!(window && window.localStorage)) return;

    const data = window.localStorage.getItem(prop);
    if (!data) return undefined;

    try {
        const result = JSON.parse(data);
        if (result !== undefined && result !== '') {
            return result as T;
        }
        return undefined;
    } catch {
        return data as T;
    }
};
export const saveToStorage = <T>(prop: string, value: T) => {
    if (typeof value === 'string') {
        window.localStorage.setItem(prop, value);
        return;
    }

    window.localStorage.setItem(prop, JSON.stringify(value));
};
export const clearStorage = (prop: string) => {
    window.localStorage.removeItem(prop);
};
